export const categoryList = {
    description:
        '一覧からテーマを探すことができます。「所属企業一覧」からテーマ内に技術（特許出願）をもつ企業の一覧情報が確認できます。',
    selectLabel: 'テーマの絞り込み',
    userSelectPlaceholder: 'カテゴリを選択してください',
    inputLabel: 'キーワード',
    userInputPlaceholder: 'キーワードを入力してください',
    column1: 'カテゴリ',
    column2: 'テーマ名',
    link: '所属企業一覧',
    search: '選択したテーマを分析する',

    // テーマに所属する企業一覧
    returnListLink: 'テーマ一覧に戻る',
    // theme: 'テーマ',
    selected: '選択中',
    countText: 'テーマ内特許件数',
    countNumber: '件',
    companyCountText: '該当企業',
    companyCountNumber: '件',
    userInputPlaceholderOfCompanyList: 'キーワードを入力して下さい',
    searchTableSelect1: '企業名',
    columnOfCompanyList1: '企業名',
    columnOfCompanyList2: '登録国',
    columnOfCompanyList9: '産業分類 (NACE)',
    columnOfCompanyList3: '特許保有割合',
    columnOfCompanyList4: '特許出願数',
    columnOfCompanyList5: '被引用数',
    columnOfCompanyList6: '売上高 [百万米ドル]',
    columnOfCompanyList7: 'マイノリティ出資 [百万円]',
    columnOfCompanyList8: 'スタートアップ',
    searchOfCompanyList: 'このテーマを分析する'
}
